import {Component, HostListener, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';
import {SnackService} from '../../services/snack/snack.service';
import {TranslateService} from '@ngx-translate/core';
import {UtilService} from '../../services/util/util.service';
import {UserService} from '../../services/user/user.service';
import {User} from '../../generated/sales-terminal-client';
import {finalize} from 'rxjs/operators';
import {cloneDeep, isEqual} from 'lodash-es';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
})
export class MyProfileComponent implements OnInit {
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return !this.isModelChanged;
  }

  public user: User;
  public userOrig: User;
  public isLoading: boolean = false;

  public get isModelChanged(): boolean {
    return !isEqual(this.user, this.userOrig);
  }

  constructor(
    public authService: AuthService,
    private snackService: SnackService,
    private translateService: TranslateService,
    public utilService: UtilService,
    private userService: UserService
  ) {}

  public ngOnInit(): void {
    this.get();
  }

  public get isValid(): boolean {
    return this.userService.isValid(this.user);
  }

  syncModels(): void {
    this.userOrig = cloneDeep(this.user);
  }

  private get(): void {
    this.isLoading = true;
    this.authService.myProfile().pipe(
      finalize(() => this.isLoading = false)
    ).subscribe((user) => {
      this.user = user;
      this.syncModels();
    });
  }

  public update(): void {
    this.isLoading = true;
    this.authService.saveMyProfile(UserService.getBasicData(this.user)).pipe(
      finalize(() => this.isLoading = false)
    ).subscribe((user) => {
      this.user = user;
      this.syncModels();
      this.authService.changeRole().subscribe();
      this.snackService.showSuccess(this.translateService.instant('general.api_my_profile_successfully_updated'));
    });
  }

  continueWithoutSaving(): void {
    this.syncModels();
  }

  saveAndContinue(): void {
    this.syncModels();
    this.update();
  }

  get pendingChangesDescription(): string {
    return this.translateService.instant('general.api_my_profile_description_unsaved_changes');
  }
}
